import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "services/users";

import { TableRow, TableCell, Box } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import CustomDialog from "./CustomDialog";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const MListTableItem = ({ user }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { accessList, accessListCurrentPage } = useSelector(
    ({ users }) => users
  );

  const handleDeleteUserUserAccess = () => {
    setOpenRemoveDialog(false);
    dispatch(
      UsersRequests.removeSingleUserAccessMangement(
        user._id,
        accessList.length,
        accessListCurrentPage
      )
    );
  };

  const getTopic = (topic) => {
    let pTopic = "";
    if (topic === "General") {
      return "عمومی";
    } else if (topic === "JoftPooch") {
      return "جفت پوچ";
    } else if (topic === "Other") {
      return "عمومی";
    }
    return pTopic;
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.identifier}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user.type === "CodeMeli" ? "کد ملی" : "کد پرسنلی"}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {getTopic(user.topic)}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {user?.topicString}
        </TableCell>

        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box
            className={classes.createIconContainer}
            onClick={() => setOpenRemoveDialog(true)}
          >
            <Delete />
          </Box>
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف دسترسی این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteUserUserAccess}
      />
    </React.Fragment>
  );
};

export default MListTableItem;
